module.exports = __webpack_public_path__ + "static/media/logo-white.25df9c21.png";